if (!customElements.get('drapeur-product-look')) {
  customElements.define('drapeur-product-look', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      if (this.initialize()) return;
      this.observer = new MutationObserver(() => this.initialize());
      this.observer.observe(this, { childList: true, subtree: true });
    }

    initialize() {
      this.dialog = this.dialog || this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return false;
      this.observer?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      document.body.append(this.dialog);
      this.triggers = Array.from(this.querySelectorAll('[data-drapeur-look-open]'));
      this.triggers.forEach(button => {
        button.hidden = false;
        button.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          this.opener = button;
          const index = button.dataset.pieceIndex;
          const items = this.dialog.querySelectorAll('[data-look-piece]');
          items.forEach(item => item.classList.toggle('is-selected', item.dataset.lookPiece === index));
          if (!this.dialog.open) this.dialog.showModal();
          const selected = this.dialog.querySelector('.is-selected');
          if (selected) selected.scrollIntoView({ block: 'nearest' });
          else this.dialog.querySelector('.drapeur-product-look__items').scrollTop = 0;
        }, options);
      });
      this.dialog.querySelectorAll('[data-look-close]').forEach(button => {
        button.addEventListener('click', () => this.dialog.close(), options);
      });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      }, options);
      return true;
    }

    disconnectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected) return;
        this.observer?.disconnect();
        if (this.dialog?.open) this.dialog.close();
        this.controller?.abort();
        this.controller = null;
        this.dialog?.remove();
      });
    }
  });
}
